import React, {useState} from 'react';
import {BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip,} from 'chart.js';
import {Bar} from 'react-chartjs-2';
import "./statschart.scss";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export function StatsChart() {
    const [chartData, setChartData] = useState([0, 0, 5000, 0, 0, 5000, 3000])
    const getData = () => {
        return 'بازدید'
    }
    const options: any = {
        responsive: true,
        scales: {
            XAxis: {
                grid: {
                    display: false,
                },
                ticks: {
                    font: {
                        family: 'yekanbakh, sans-serif',
                        size: 12,
                        color: '#2B2D42',
                        weight: 400,
                    },
                    textStrokeWidth: 0,
                    backdropColor: 'rgba(0, 0, 0, 0)',
                },
            },
            YAxis: {
                border: {
                    display: false
                },
                ticks: {
                    font: {
                        family: 'yekanbakh, sans-serif',
                        size: 12,
                        color: '#2B2D42',
                        weight: 300,
                    },
                    padding: 20,
                    stepSize: 1000,
                },
            }
        },
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                backgroundColor: '#EF233C',
                titleAlign: 'right',
                footerAlign: 'right',
                titleFont: {
                    family: 'yekanbakh, sans-serif',
                    size: 14,
                    color: '#2B2D42',
                    weight: 400,
                },
                bodyFont: {
                    family: 'yekanbakh, sans-serif',
                    size: 14,
                    color: '#2B2D42',
                    weight: 400,
                },
                callbacks: {
                    title: getData,
                },
                padding: 9,
                displayColors: false
            }
        }
    };

    const labels = [' ویدئو', 'همسان', 'بنری', 'رپورتاژ', 'اینفلوئنسری', 'گوگل', 'تیزراستانی'];

    const data = {
        labels,
        datasets: [
            {
                data: chartData,
                borderRadius: 12,
                backgroundColor: '#2B2D42',
                hoverBackgroundColor: '#EF233C',
                barThickness: 20,
                xAxisID: "XAxis",
                yAxisID: "YAxis"
            }
        ],
    };

    return <Bar options={options} data={data}/>;
}
